import React from 'react';
import Header from '../common/Header';  // Correct path to Header

const Layout = ({ children, showHeader = true, showHeaderMobile = true }) => {
  return (
    <div className="min-h-screen bg-[#050A12]">
      {showHeader && (
        <div className={showHeaderMobile ? '' : 'hidden sm:block'}>
          <Header />
        </div>
      )}
      <main className="flex-1">
        {children}
      </main>
    </div>
  );
};

export default Layout;